import { render, staticRenderFns } from "./CartMobileWeek.vue?vue&type=template&id=08522b2a&"
import script from "./CartMobileWeek.vue?vue&type=script&lang=js&"
export * from "./CartMobileWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports